<template>
  <!-- klasa editable dodaje edycje -->
  <div
    class="feature-icon-box"
    :class="[
      { 'has-bg': backgroundColor || backgroundClass },
      backgroundColor ? '' : backgroundClass,
      layout,
    ]"
    :style="backgroundColor ? `backgroundColor: ${backgroundColor}` : ''"
  >
    <div class="feature-icon-box-content" :class="{ 'no-icon': !hasMain?.fileData }">
      <ContentGeneratorElementsMedia v-if="hasMain?.fileData" aspect-ratio-mobile="1/1" aspect-ratio="1/1" :value="content.media" class="feature-icon-box-icon" />
      <ContentGeneratorElementsText :content="content.text" />
    </div>
  </div>
</template>
<script>
import ContentGeneratorElementsMedia from '../elements/Media.vue'
import ContentGeneratorElementsText from '../elements/Text.vue'
import { contentFindContent, contentFindOption } from '../../../plugins/content'
export default {
  components: {
    ContentGeneratorElementsMedia,
    ContentGeneratorElementsText
  },
  props: {
    value: { type: Object, default: null }
  },
  computed: {
    content () {
      return {
        media: contentFindContent(this.value?.content, 'media'),
        text: contentFindContent(this.value?.content, 'text')
      }
    },
    hasMain () {
      return contentFindContent(this.content.media.content, 'main')
    },
    layout () {
      return contentFindOption(this.value.options, 'layout').value || 'photo-left'
    },

    backgroundColor () {
      return contentFindOption(this.value.options, 'backgroundColor').value || null
    },
    backgroundClass () {
      return contentFindOption(this.value.options, 'backgroundClass').value || null
    }
  }
}
</script>

<style lang="scss" scoped>
.feature-icon-box {
  width: 100%;

  :deep(.text) {
    :is(h1, h2, h3, h4, h5, h6):first-child {
      margin-top: 0;
      margin-bottom: 12px;
            font-size: 24px !important;
      font-weight: 600;
    }

    :last-child {
      margin-bottom: 0;
    }

    p {
      font-size: 16px;
    }

    word-break: keep-all;
  }

  :deep(figure) {
    border-radius: unset;
    img{
      border-radius: unset;
    }
  }

  &.photo-left {
    :deep(.photo-wrapper) {
      position: absolute !important;
      top: -2px;
      left: 0;
    }
  }

  &.has-bg {
    border-radius: 12px;

    .feature-icon-box-content {
      padding: 40px;

      &.no-icon {
        padding: 40px;
      }
    }

    .feature-icon-box-icon {
      height: 40px;
      width: 40px;
      top: 38px;
      left: 40px;

      & + .text-container > :deep(.text) > div > :not(:first-child) {
        margin-left: -52px;
      }
    }

  }

  .feature-icon-box-content {
    width: 100%;
    position: relative;

    &:not(.no-icon) {
      display: flex;
      align-items: center;

      :deep(.text) {
        p:first-child {
          font-size: 24px;
          font-weight: 600;
          margin: 0;
        }
        :is(p, h1, h2, h3, h4, h5, h6):first-child{
          padding-left: 45px;
        }
      }
    }

    &.no-icon {
      padding: 8px 16px;

      :deep(.text-container) {
        p:first-child {
          padding-left: 0 !important;
          margin-top: 0 !important;
          padding-top: 0;
        }
      }
    }

    :deep(.text-container) {
      width: 100%;
    }

     :deep(img){
      height: 40px;
      width: 40px;
      }

  }

  &.photo-top {
    display: flex;
    align-items: center;
    justify-content: center;

    :deep(.text-container) {
      padding-left: 0 !important;
      .text{
        :is(p, h1, h2, h3, h4, h5, h6):first-child{
        padding-left: 0;
      }
      }

    }

    :deep(.photo-wrapper) {
      position: static;
      height: 40px;
      width: 40px;
      img{
        width: 40px;
        height: 40px;
      }
    }

    & > .feature-icon-box-content {
      height: 100%;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      :deep(.photo-wrapper) {
        margin-bottom: 12px;
        height: fit-content;

        >div {
          height: fit-content;
        }
      }
    }
  }
}
</style>
